/**
 * A page-wide count of work in flight, with its subscribers. A preview status reads it to show that
 * something is still loading, and a capture harness waits for that status to detach.
 */
import { createExternalStore } from '../r3f/hooks/createExternalStore.js';
/** @canonical A page-wide count of work in flight */
export function createWorkCount() {
    const store = createExternalStore(0);
    return {
        begin() {
            store.set(store.get() + 1);
            let ended = false;
            return () => {
                if (ended)
                    return;
                ended = true;
                store.set(store.get() - 1);
            };
        },
        pending: store.get,
        subscribe: store.subscribe,
    };
}
//# sourceMappingURL=workCount.js.map